














import Widget from "@/components/common/Widget.vue";
import VerticalSingleBar from "@/components/charts/VerticalSingleBar.vue";
import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";

import Component from "vue-class-component";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
    VerticalSingleBar,
  },
})
export default class BetriebsergebnisGesamt extends Vue {
  public static id = "BetriebsergebnisGesamt";
  public static dprops = { width: 4, height: 4, minWidth: 2, minHeight: 2 };
  get _id() {
    return BetriebsergebnisGesamt.id;
  }
  get _dprops() {
    return BetriebsergebnisGesamt.dprops;
  }
}
